export default __webpack_public_path__ + "static/media/rings.2dc56a74.png";